import React, {ReactElement} from "react";
import {DW_LG, PD_XLG, SZ_XLG} from "shared/dimens";
import {Box, TextField, Typography} from "@mui/material";
import {DialogFragment, PageFragment, PageFragmentProps, PageFragmentState} from "shared/PageFragment";
import {StyledBoxRow} from "shared/StyledComponents";

export type AddDeviceSetupCodeFragmentProps = PageFragmentProps & {
  finish: (setupCode: string) => void,
}

type AddDeviceSetupCodeFragmentState = PageFragmentState & {
  setupCodeParts: string[],
}

export class AddDeviceSetupCodeFragment extends DialogFragment<AddDeviceSetupCodeFragmentProps, AddDeviceSetupCodeFragmentState> {

  private static MAX_LENGTH = 3;

  protected onCreateState(): AddDeviceSetupCodeFragmentState {
    return {
      ...super.onCreateState(),
      title: "Link device",
      setupCodeParts: ["", "", ""],
      actionButtonDisabled: true,
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return "Link device";
  }

  onActionButtonClicked() {
    this.props.finish(this.state.setupCodeParts.join(""));
  }

  renderContent(): ReactElement {
    return <Box style={{
      display: "flex",
      flexDirection: "column",
      padding: PD_XLG,
      gap: PD_XLG,
      maxWidth: DW_LG,
      alignItems: "center"
    }}>
      <Typography style={{textAlign: "center"}}>
        Please make sure your device is turned on and you have connected it to your WiFi. Your device is ready to set
        up when you can see a 9-letter code on your device's screen.
      </Typography>
      <StyledBoxRow>
        {this.renderTextField(0)}
        {this.renderTextField(1)}
        {this.renderTextField(2)}
      </StyledBoxRow>
      <Typography variant="caption" style={{textAlign: "center"}}>Can't see the 9-letter code on your device
        screen? Please ensure your Device is switched on and you have
        successfully connected to your WiFi network by following the instructions in the Quick Start Guide.</Typography>
    </Box>;
  }

  private renderTextField(index: number) {
    const onKeyDown = event => {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.props.finish(this.state.setupCodeParts.join(""));
        return;
      }
    };
    return <TextField
      id={"add-device-text-" + index}
      style={{width: SZ_XLG}}
      autoFocus={index === 0}
      type="text" required onKeyDown={onKeyDown}
      inputProps={{
        maxLength: AddDeviceSetupCodeFragment.MAX_LENGTH,
        style: {fontSize: "200%", fontWeight: "bold", textAlign: "center"}
      }}
      value={this.state.setupCodeParts[index]}
      onChange={event => {
        const parts = [...this.state.setupCodeParts];
        parts[index] = event.target.value?.trim().toUpperCase() || "";
        this.setState({setupCodeParts: parts, actionButtonDisabled: parts.join("").length < 9});
        if (parts[index].length === AddDeviceSetupCodeFragment.MAX_LENGTH && index < 2) {
          const element = document.getElementById("add-device-text-" + (index + 1));
          element.focus();
        }
      }}/>;
  }
}
